import { render, staticRenderFns } from "./QualificationInfoTalentFind.vue?vue&type=template&id=a90f2934"
import script from "./QualificationInfoTalentFind.vue?vue&type=script&lang=js"
export * from "./QualificationInfoTalentFind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports